import axios from "axios";
const BASEURL = ""; //process.env.REACT_APP_API_URL;

export const Get = (url, data = {}) => {
  return axios.get(BASEURL + url, { params: data });
};

export const Post = (url, data) => {
  return axios.post(BASEURL + url, data);
};

export const Update = (url, data) => {
  return axios.put(BASEURL + url, data);
};

export const Remove = (url) => {
  return axios.delete(BASEURL + url);
};

export const getApiUrl = () => {
  //console.log(`Host Name: ${window.location.hostname}`);
  
  if (window.location.hostname.toLowerCase().startsWith("localhost"))
    return "https://devdashboardapi.enrichmycare.com/api";
    //return "https://localhost:44371/api";
  else if (window.location.hostname.toLowerCase().startsWith("devdashboard.enrichmycare.com"))
    return "https://devdashboardapi.enrichmycare.com/api";
  else if (window.location.hostname.toLowerCase().startsWith("qadashboard.enrichmycare.com"))
    return "https://qadashboardapi.enrichmycare.com/api";
  else if (window.location.hostname.toLowerCase().startsWith("dashboard.enrichmycare.com"))
    return "https://dashboardapi.enrichmycare.com/api";
  else
    return "";
}

export const getShareRecordUrl = () => {
  if (window.location.hostname.toLowerCase().startsWith("localhost"))
    return "https://devprofessional.enrichmycare.com/";
  else if (window.location.hostname.toLowerCase().startsWith("devdashboard.enrichmycare.com"))
    return "https://devprofessional.enrichmycare.com/";
  else if (window.location.hostname.toLowerCase().startsWith("qadashboard.enrichmycare.com"))
    return "https://qaprofessional.enrichmycare.com/";
  else if (window.location.hostname.toLowerCase().startsWith("dashboard.enrichmycare.com"))
    return "https://professional.enrichmycare.com/";
  else
    return "";
}